<template>
  <div
    class="tw-flex tw-flex-wrap tw-items-center md:tw-items-end tw-gap-[16px] tw-ps-[22px] md:tw-ps-[46px] md:tw-pe-[40px]"
  >
    <h1
      class="tw-mb-0 tw-text-[var(--my-white-soft2)] md:tw-text-[var(--my-primary)] tw-text-[25px] md:tw-text-[35px] tw-leading-[1.2] tw-font-black"
    >
      {{ $t("dashboard.my_contacts_title", "Team Management") }}
    </h1>

    <button
      :disabled="loadingList"
      @click="exportContactList"
      class="export-btn"
      v-b-tooltip.hover.top="'Export Contacts'"
    >
      <b-spinner v-if="loadingList" size="sm" />
      <icon-upload v-else />
    </button>
    <button
      :disabled="loadingList"
      @click="() => this.$root.$emit('bv::show::modal', 'my-import-contacts-org-popup')"
      class="import-btn"
      v-b-tooltip.hover.top="'Import Contacts'"
    >
      <b-spinner v-if="loadingList" size="sm" />
      <icon-upload v-else />
    </button>
  </div>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls";
import iconUpload from "@/views/my-contacts/icons/upload.vue";
import { useTeamLeaderContacts } from "@/composables/useDashboardTeamLeaderContacts";

export default {
  setup() {
    const { campaignId } = useTeamLeaderContacts();

    return { campaignId };
  },
  name: "contact-list-header",
  data() {
    return {
      loadingList: false,
    };
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    iconUpload,
  },

  methods: {
    async exportContactList() {
      this.loadingList = true;

      const orgId = localStorage.getItem("orgId");
      const url = urls.orgTeamLeaderContactsExport(orgId, this.campaignId);

      try {
        const { data } = await axios.get(url);
        const link = data.meta?.link;

        if (link) {
          const a = document.createElement("a");
          a.href = link;
          a.download = "";
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          console.error("Download link not found in response.");
        }
      } catch (err) {
        console.error("Failed to export contacts:", err);
      } finally {
        this.loadingList = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.export-btn {
  @apply tw-flex tw-items-center tw-justify-center tw-w-[44px] tw-h-[44px] tw-rounded-full tw-bg-[var(--event-secondary)];
}
.import-btn {
  @apply tw-flex tw-items-center tw-justify-center tw-w-[44px] tw-h-[44px] tw-rounded-full tw-bg-[var(--event-secondary)] tw-rotate-180;
}
</style>
